import React from 'react';

/**
 * Sektions-Header in der Command-Liste.
 * Klein, dezent, uppercase — Linear/Notion-Style.
 */
export default function SectionHeader({ label, count }) {
  return (
    <div className="px-3 pt-3 pb-1 flex items-center justify-between select-none">
      <span className="text-[10px] font-semibold tracking-wider uppercase text-gray-400 dark:text-slate-500">
        {label}
      </span>
      {typeof count === 'number' && count > 0 && (
        <span className="text-[10px] text-gray-300 dark:text-slate-600">{count}</span>
      )}
    </div>
  );
}
